import * as React from 'react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { IIconProps } from 'office-ui-fabric-react/lib/Icon';

const styles = require('./IconWell.scss');

export const IconDetailView = function IconDetailView(props: IIconProps) {
    return <Icon {...props} className={styles.icon} />;
};

export const IconWell = function IconWell(props: { icons: IIconProps[] }) {
    const { icons } = props;
    return (
        <div className={styles.iconWell}>
            {icons.map((iconDetails, index) => (
                <IconDetailView {...iconDetails} key={index} />
            ))}
        </div>
    );
};
